"use client";

import { motion } from "framer-motion";
import styles from "./WhyChooseUs.module.css";
import { CheckCircle, Clock, Users, ArrowRight } from "lucide-react";
import Link from "next/link";

export default function WhyChooseUs() {
  const features = [
    {
      icon: <CheckCircle size={28} color="#007bff" />,
      title: "Chất lượng đảm bảo",
      description:
        "Mọi sản phẩm đều được kiểm tra kỹ lưỡng và đảm bảo chất lượng cao nhất.",
    },
    {
      icon: <Clock size={28} color="#007bff" />,
      title: "Hỗ trợ 24/7",
      description:
        "Luôn sẵn sàng hỗ trợ và giải đáp mọi thắc mắc của khách hàng.",
    },
    {
      icon: <Users size={28} color="#007bff" />,
      title: "Đội ngũ chuyên nghiệp",
      description:
        "Đội ngũ chuyên gia giàu kinh nghiệm và tận tâm với từng dự án.",
    },
  ];

  return (
    <section className={styles.whyChooseSection}>
      {/* Tiêu đề */}
      <motion.h2
        className={styles.whyChooseTitle}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Tại sao chọn chúng tôi?
      </motion.h2>

      <motion.p
        className={styles.whyChooseSubtitle}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        viewport={{ once: true }}
      >
        Chúng tôi cam kết mang đến giá trị vượt trội cho mọi dự án
      </motion.p>

      {/* Danh sách 3 tính năng */}
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className={styles.featureItem}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className={styles.featureIcon}>{feature.icon}</div>
            <h3 className={styles.featureTitle}>{feature.title}</h3>
            <p className={styles.featureDescription}>{feature.description}</p>
          </motion.div>
        ))}
      </div>

      {/* Hai nút CTA */}
      <motion.div
        className={styles.ctaButtons}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        viewport={{ once: true }}
      >
        <Link href="/dat-lich" className={styles.btnOutline}>
          Liên hệ tư vấn ngay
        </Link>
        <Link href="/san-pham" className={styles.btnPrimary}>
          Tìm hiểu các sản phẩm <ArrowRight size={16} />
        </Link>
      </motion.div>
    </section>
  );
}
